import React from "react";
import { FaRobot, FaMicrophone, FaDatabase, FaPenNib } from "react-icons/fa";
import { MdOutlineCurrencyExchange } from "react-icons/md";

function BlockCDevS() {
  return (
    <>
      <div style={{ padding: "80px 0", background: "#fff" }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div
                className="ce-deliver-img text-center d-flex align-items-center justify-content-center"
                style={{ minHeight: "350px" }}
              >
                <MdOutlineCurrencyExchange
                  style={{
                    fontSize: "16rem",
                    color: "#0a1f44",
                    filter: "drop-shadow(0 20px 40px rgba(0,0,0,0.1))",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <h2
                className="fw-bold mb-3"
                style={{
                  color: "#0a1f44",
                  fontSize: "clamp(22px, 2.5vw, 36px)",
                }}
              >
                Blockchain Development Solutions: Building a Scalable Future in
                the Web3 Economy
              </h2>
              <p className="text-muted mb-4" style={{ lineHeight: "1.8" }}>
                As the demand for sustainable solutions rises, blockchain
                technology is essential for verifying ethical practices and
                improving security, efficiency, transparency, and compliance
                across various industries. Xeer Technology stands out as a
                premier blockchain development company, having completed over
                1,000 projects since inception. Our expert team specializes in
                delivering custom blockchain development solutions for
                businesses worldwide.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockCDevS;
